// Core Combinators
export const and =
  (...functionList) =>
  (...params) =>
    functionList.every((func) => func(...params));

export const or =
  (...functionList) =>
  (...params) =>
    functionList.some((func) => func(...params));

export const none =
  (...functionList) =>
  (...params) =>
    functionList.every((func) => !func(...params));

export const not =
  (func) =>
  (...params) =>
    !func(...params);

export const always = () => true;

export const never = () => false;
